const { gtm, getGTMId } = require('./gtm.cjs');
const { ytm, ytmNoScript, ytmCookie, ytmSendUserParams, ytmSendEvent } = require('./ytm.cjs');

const { antiFraud, alfaPartners, groupIB } = require('./partners.cjs');
const { pixelHeadScript, pixelBodyScript } = require('./pixel.cjs');
const { dataLayerListener } = require('./data-layer.cjs');
const { platformIdReady } = require('./platform-id-ready.cjs');
const { juicyScoreConfigScript, juicyScoreMainScript } = require('./juicy-score.cjs');

const getCounters = (url, data) => {
    const {
        CUSTOM_YTM_ID,
        ENABLE_COUNTERS,
        PIL_ENABLE_GROUP_IB,
        PIL_ENABLE_JUICY_SCORE,
        PIL_ENABLE_PIXEL
    } = process.env;
    const {
        collectorData: { host }
    } = data;
    const gtmId = getGTMId(host);
    const isCountersEnabled = ENABLE_COUNTERS === 'true';
    const enableYtm = isCountersEnabled && CUSTOM_YTM_ID;
    const ytmScripts = [ytmNoScript, ytmCookie, dataLayerListener, ytmSendUserParams, ytmSendEvent];

    const juicyScoreScripts = [juicyScoreConfigScript, juicyScoreMainScript];

    const headJuicyScore = PIL_ENABLE_JUICY_SCORE === 'true' ? juicyScoreScripts.join('') : '';
    const headGroupIB = PIL_ENABLE_GROUP_IB === 'true' ? groupIB : '';
    const headGTM = isCountersEnabled ? gtm(gtmId) : '';
    const headYTM = enableYtm ? ytm(url) : '';
    const bodyYTM = enableYtm ? ytmScripts.join('') : '';
    const [headPixel, bodyPixel] =
        PIL_ENABLE_PIXEL === 'true' ? [pixelHeadScript, pixelBodyScript] : ['', ''];

    return {
        headCounters: [platformIdReady, headGroupIB, headGTM, headYTM, headPixel, headJuicyScore],
        bodyCounters: [
            bodyYTM,
            isCountersEnabled ? alfaPartners(url) : '',
            isCountersEnabled ? antiFraud : ''
        ],
        endBodyCounters: [bodyPixel]
    };
};

module.exports = {
    getCounters
};
